
if(!customElements.get('predictive-search')){
  class PredictiveSearch extends HTMLElement {
    constructor(){
      super();

      this.init();
      this.initPredictiveSearch();
    }

    init(){
      this.btnClose = this.querySelector('.btn-close');
      this.inputSearch = this.querySelector('input[type="search"]');
      this.btnClose.addEventListener('click', () => {
        this.closeSidebar();
      });
    }

    refresh(){
      this.init();
    }

    openSidebar(){
      this.previouslyFocusedElement = document.activeElement;

      document.querySelector('html').style.overflow = 'hidden';
      this.setAttribute('data-hidden', 'false');

      setTimeout(() => {
        this.inputSearch.focus();
      }, 1000);

      document.addEventListener('keydown', (event) => {
        if(event.key === 'Escape') this.closeSidebar();
      })
    }

    closeSidebar(){
      this.setAttribute('data-hidden', 'true');
      document.querySelector('html').style.overflow = 'initial';

      if(this.previouslyFocusedElement){
        this.previouslyFocusedElement.focus();
      }
    }

    initPredictiveSearch(){
      if(this.dataset.enablePredictiveSearch != 'true') return;

      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.loadingBar = this.querySelector('#predictive-search__loading-state');

      // get options
      this.showVendor = this.predictiveSearchResults.dataset.showVendor;
      this.showPrice = this.predictiveSearchResults.dataset.showPrice;
      this.numItem = this.predictiveSearchResults.dataset.numItem;
      
      this.promotions = this.querySelector('.sidebar__search-bar-promotions');

      this.input.addEventListener('input', this.debounce((e) => {
          // loading status
          this.loadingBar.setAttribute('data-hidden', 'false');

          // clear search result
          this.predictiveSearchResults.querySelector('.custom-container').innerHTML = '';

          this.onChange(e);
      }, 300).bind(this));
    }

    onChange(){
        const searchTerm = this.input.value.trim();

        if(!searchTerm.length) {
          this.close();
          return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm){
       const root = window.Shopify?.routes?.root || '/';
        fetch(
          `${root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[limit]=${parseInt(this.numItem)}&section_id=predictive-search&resources[limit_scope]=each`
        )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.predictiveSearchResults.querySelector('.custom-container').innerHTML = resultsMarkup;

          //add loading
          this.loadingBar.setAttribute('data-hidden', 'true');

          // hide promotions
          if(this.promotions) this.promotions.setAttribute('data-hidden', 'true');

          this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
    }

    open() {
      //check options to be displayed or not
      if(this.showVendor == 'false'){
        this.allVendors = this.predictiveSearchResults.querySelectorAll('.vendor');
        this.allVendors.forEach(function(item){
          item.style.display = 'none';
        })
      }

      if(this.showPrice == 'false'){
        this.allPrices = this.predictiveSearchResults.querySelectorAll('.price');
        this.allPrices.forEach(function(item){
          item.style.display = 'none';
        })
      }

      this.predictiveSearchResults.style.display = 'block';

      this.backgroundBlock = this.querySelector('.sidebar__search-bar-background');
      this.backgroundBlock.style.height = `calc(${this.querySelector('.sidebar__search-bar-content-wrapper').offsetHeight}px + 2rem)`;
    }

    close(){
      this.predictiveSearchResults.style.display = 'none';

      // add loading status
      this.loadingBar.setAttribute('data-hidden', 'true');

      // show promotions
      if(this.promotions) this.promotions.setAttribute('data-hidden', 'false');

      this.isOpen = false;
    }

    debounce(fn, wait){
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}